// extracted by mini-css-extract-plugin
module.exports = {"icon":"ManageAppsIntegrationIcon_icon__25txj"};